<template>
  <div class="tabs-wrapper">
    <div class="tabs-box">
      <button
        v-for="tab in tabs"
        :key="tab"
        :class="['tab-box', { active: value === tab }]"
        :disabled="disabled"
        @click="$emit('input', tab)"
      >
        {{ tab }}
      </button>
    </div>

    <div class="tab-content">
      <slot :activeTab="value" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'AccountTabs',

    props: {
        tabs: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }

    }
}
</script>

<style scoped>
.tabs-wrapper {
  width: 100%;
}

.tabs-box {
  max-height: 40px;
  display: inline-flex;
  background: #f1f1f1;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 40px;
}

 .tab-box {
  border: none;
  background: transparent;
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  transition: all 0.2s ease;
}

.tab-box.active {
  margin-bottom: -.5px;
  background: #fff;
  color: #000;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-weight: 500;
}
</style>
